<template>
	<main class="new-not-found">
		<div class="new-not-found__content new-layout-container">
			<img
				class="new-not-found__error-image"
				src="/static/error404.jpg"
				alt="Oops! 404"
			>

			<h1>Página não encontrada</h1>
			<a href="/calendar">Continue usando o nosso site</a>

			<img
				class="new-not-found__logo"
				src="/static/logo_pt.png"
				alt="Blumar Congressos e Eventos"
			>
		</div>
	</main>
</template>

<script>
export default {
	metaInfo: {
		title: 'Página não encontrada',
	},
};
</script>

<style scoped lang="scss">
.new-not-found {
	display: flex;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
	min-height: 55vh;
	padding: 70px 0 90px;
	background: #ffffff;
}

.new-not-found__content {
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
}

.new-not-found__error-image {
	display: block;
	width: 157px;
	height: auto;
}

.new-not-found h1 {
	margin: 28px 0 2px;
	color: #4c4b4b;
	font-size: 27px;
	font-weight: 700;
	line-height: 32px;
	text-transform: uppercase;
}

.new-not-found a {
	color: #2abf9f;
	font-size: 18px;
	font-weight: 700;
	line-height: 24px;
	text-decoration: none;
	text-transform: uppercase;
}

.new-not-found a:hover,
.new-not-found a:focus-visible {
	color: #0b3a52;
	text-decoration: underline;
}

.new-not-found__logo {
	display: block;
	width: 175px;
	height: auto;
	margin-top: 32px;
}

@media (max-width: 600px) {
	.new-not-found {
		min-height: 60vh;
		padding: 60px 0 75px;
	}

	.new-not-found__error-image {
		width: 140px;
	}

	.new-not-found h1 {
		font-size: 22px;
		line-height: 27px;
	}

	.new-not-found a {
		font-size: 15px;
		line-height: 21px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/errors/NotFound.vue